import { Outlet } from "react-router-dom";

import Sidebar from "../components/sidebar/Sidebar";
import Navbar from "../components/navbar/Navbar";

import "./dashboardLayout.css";

function DashboardLayout() {

return (

<div className="dashboard-layout">

<Sidebar />

<div className="dashboard-main">

<Navbar />

<div className="dashboard-content">

<Outlet />

</div>

</div>

</div>

)

}

export default DashboardLayout;